import React from 'react'

function PostNumber(props){
    return <div><p className="postnumber">number of images: {props.number}</p></div>
}

export default PostNumber